import React, { useEffect } from 'react';
// Trigger HMR update
import { BrowserRouter as Router, Routes, Route, useLocation } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { PublicationsProvider } from './contexts/PublicationsContext';
import { StudentsProvider } from './contexts/StudentsContext';
import { CoursesProvider } from './contexts/CoursesContext';
import { TeachersProvider } from './contexts/TeachersContext';
import { ThemeProvider } from './contexts/ThemeContext';
import Home from './pages/Home';
import Login from './pages/auth/Login';
import ForgotPassword from './pages/auth/ForgotPassword';
import ResetPassword from './pages/auth/ResetPassword';
import VerifyEmail from './pages/auth/VerifyEmail';
import Dashboard from './pages/dashboard/Dashboard';
import PublicationsManager from './pages/publications/PublicationsManager';
import Students from './pages/students/Students';
import Courses from './pages/courses/Courses';
import Professors from './pages/professors/Professors';
import Reports from './pages/reports/Reports';
import Settings from './pages/settings/Settings';
import ProtectedRoute from './pages/ProtectedRoute';
import AboutPage from './pages/AboutPage';
import FormationsPage from './pages/FormationsPage';
import StudentLifePage from './pages/StudentLifePage';
import ContactPage from './pages/ContactPage';
import PublicationDetail from './pages/PublicationDetail';
import { Toaster } from "./components/ui/toaster";
import GalleryPage from 'pages/GalleryPage';
import Profil from 'pages/auth/Profil';

function ScrollToHash() {
  const location = useLocation();

  useEffect(() => {
    const hash = location.hash;

    if (hash) {
      const id = hash.substring(1);
      const element = document.getElementById(id);

      if (element) {
        element.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
    } else {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [location]);

  return null;
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <PublicationsProvider>
          <StudentsProvider>
            <CoursesProvider>
              <TeachersProvider>
                <Router>
                  <ScrollToHash />
                  <div className="App">
                    <Routes>
                      <Route path="/" element={<Home />} />
                      <Route path="/a-propos" element={<AboutPage />} />
                      <Route path="/galerie" element={<GalleryPage />} />
                      <Route path="/formations" element={<FormationsPage />} />
                      <Route path="/vie-etudiante" element={<StudentLifePage />} />
                      <Route path="/contact" element={<ContactPage />} />
                      <Route path="/publication/:id" element={<PublicationDetail />} />
                      <Route path="/login" element={<Login />} />
                      <Route path="/forgot-password" element={<ForgotPassword />} />
                      <Route path="/reset-password" element={<ResetPassword />} />
                      <Route path="/verify-email" element={<VerifyEmail />} />
                      <Route
                        path="/dashboard"
                        element={
                          <ProtectedRoute>
                            <Dashboard />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path="/publications"
                        element={
                          <ProtectedRoute>
                            <PublicationsManager />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path="/students"
                        element={
                          <ProtectedRoute>
                            <Students />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path="/courses"
                        element={
                          <ProtectedRoute>
                            <Courses />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path="/professors"
                        element={
                          <ProtectedRoute>
                            <Professors />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path="/reports"
                        element={
                          <ProtectedRoute>
                            <Reports />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path="/settings"
                        element={
                          <ProtectedRoute>
                            <Settings />
                          </ProtectedRoute>
                        }
                      />
                      <Route
                        path="/profile"
                        element={
                          <ProtectedRoute>
                            <Profil />
                          </ProtectedRoute>
                        }
                      />
                    </Routes>
                  </div>
                </Router>
                <Toaster />
              </TeachersProvider>
            </CoursesProvider>
          </StudentsProvider>
        </PublicationsProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
